import type { ProjectElementNode } from '@deltek/specification-client/core/Models/productListingDetail'

export interface PTMutationInput {
    projectId: string
    baseElementId: string | undefined
    nodeId: string
    treePath: string | undefined
    isProductFamilyGroupView: boolean
}

/**
 * Prepares GraphQL mutation inputs for adding PT nodes to project
 * @param ptNode - The Product Type element node
 * @param projectId - The current project ID
 * @param selectedElementFormat - The current selected element format (e.g., 'DIVISIONS')
 * @returns PTMutationInput object for the mutation
 *
 * @example
 * const ptNode = {
 *   baseElementId: 'base123',
 *   id: 'node456',
 *   treePath: 'some/tree/path',
 *   isInProject: false
 * }
 * const projectId = 'proj789'
 * const selectedElementFormat = 'DIVISIONS'
 * const mutationInput = preparePTMutationInputs(ptNode, projectId, selectedElementFormat)
 * // Returns {
 *      projectId: 'proj789',
 *      baseElementId: 'base123',
 *      nodeId: 'node456',
 *      treePath: 'some/tree/path',
 *      isProductFamilyGroupView: true
 *    }
 */
export const preparePTMutationInputs = (
    ptNode: ProjectElementNode,
    projectId: string | undefined,
    selectedElementFormat: string | undefined
): PTMutationInput => {
    if (!ptNode.baseElementId || !ptNode.id) {
        throw new Error('PT element node is missing required IDs')
    }

    return {
        projectId: projectId ?? '',
        baseElementId: ptNode.baseElementId,
        nodeId: ptNode.id,
        treePath: ptNode.treePath,
        isProductFamilyGroupView: selectedElementFormat === 'DIVISIONS',
    }
}
